module.exports = __webpack_public_path__ + "img/logo-mono.6153257b.png";